'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$UpdateA3(username, pin, serial, thumbprint, location) {
  this.a0j = null;
  this.a0g = null;
  this.a0h = null;
  this.a0i = null;
  this.a0f = null;
  this.a0j = username;
  this.a0g = pin;
  this.a0h = serial;
  this.a0i = thumbprint;
  this.a0f = location;
}
export { $c_Lpresto_types$proto$UpdateA3 as $c_Lpresto_types$proto$UpdateA3 };
$p = $c_Lpresto_types$proto$UpdateA3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$UpdateA3;
/** @constructor */
function $h_Lpresto_types$proto$UpdateA3() {
}
export { $h_Lpresto_types$proto$UpdateA3 as $h_Lpresto_types$proto$UpdateA3 };
$h_Lpresto_types$proto$UpdateA3.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$UpdateA3)) {
    if ((this.a0j === x$0.a0j)) {
      var x = this.a0g;
      var x$2 = x$0.a0g;
      var $x_3 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$3 = this.a0h;
      var x$4 = x$0.a0h;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.a0i;
      var x$6 = x$0.a0i;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.a0f;
      var x$8 = x$0.a0f;
      return ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 5;
});
$p.s = (function() {
  return "UpdateA3";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.a0j;
      break;
    }
    case 1: {
      return this.a0g;
      break;
    }
    case 2: {
      return this.a0h;
      break;
    }
    case 3: {
      return this.a0i;
      break;
    }
    case 4: {
      return this.a0f;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_types$proto$UpdateA3(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.mc)));
}
export { $isArrayOf_Lpresto_types$proto$UpdateA3 as $isArrayOf_Lpresto_types$proto$UpdateA3 };
var $d_Lpresto_types$proto$UpdateA3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$UpdateA3, "presto.types$proto$UpdateA3", ({
  mc: 1,
  bx: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$UpdateA3 as $d_Lpresto_types$proto$UpdateA3 };
//# sourceMappingURL=presto.types$proto$-Update-A3.js.map
